module.exports = __webpack_public_path__ + "img/mcn1.80bf9d57.gif";